/**
 * @author rmh
 * 模块说明：采购分仓
 */
import { Service } from '@/tools'

export class WarehouseConfigService<T extends TProcure.WarehouseConfig> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TProcure.WarehouseConfig}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 模块说明：列表相关接口
   */
  pageSubWarehouseInfo = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiPage', data)
  }

  /**
   * 模块说明：立即生效
   */
  startWarehouse = <K extends T['ApiStartWarehouse']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiStartWarehouse', data, '操作成功')
  }
  /**
   * 模块说明：失效采购分仓
   */
  enableWarehouse = <K extends T['ApiEnableWarehouse']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiEnableWarehouse', data, '操作成功')
  }

  /**
   * 模块说明：删除采购分仓
   */
  deleteWarehouse = <K extends T['ApiEnableWarehouse']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiDeleteWarehouse', data, '操作成功')
  }

  /**
   * 模块说明：新增采购分仓
   */
  addWarehouse = <K extends T['ApiAddWarehouse']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiAddWarehouse', data, '操作成功')
  }

  /**
   * 采购分仓详情
   * @param {object} params AggrWarehouseQuery
   * @param {number} params.warehouseId  采购分仓Id
   * @returns
   */
  queryWarehouse = <K extends T['ApiQueryWarehouse']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiQueryWarehouse', data)
  }
  /**
   * 修改采购分仓
   * @param {object} params AggrWarehouseQuery
   * @param {number} params.warehouseId  采购分仓Id
   * @returns
   */
  editWarehouse = <K extends T['ApiEditWarehouse']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiEditWarehouse', data)
  }
}
